import { Observable, of, throwError } from 'rxjs';

export class HttpHelper {

  public static defaultRequestOptions = { withCredentials: true };

  public static handleError<T>(operation = 'operation', result?: T, rethrow: boolean = false): (error: any) => Observable<T> {

    return (error: any): Observable<T> => {
      // log error
      console.error(`${operation} : ${error}`);


      if (rethrow) {
        return throwError(error);
      }

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}
